import { render, staticRenderFns } from "./BaseField.global.vue?vue&type=template&id=2c2cc419&"
import script from "./BaseField.global.vue?vue&type=script&lang=js&"
export * from "./BaseField.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports